const flattenExperience = (experience) =>
  experience
    .map((item) => {
      const highlights = item.highlights.map((point) => `- ${point}`).join("\n");
      return `${item.role} at ${item.company} (${item.period})\n${highlights}`;
    })
    .join("\n\n");

const flattenProjects = (projects) =>
  projects
    .map(
      (project) =>
        `${project.name}: ${project.description} Tech: ${project.tech.join(", ")}. Outcome: ${project.outcome}`
    )
    .join("\n\n");

const defaultPrompt =
  "Try asking about experience, projects, skills, contact, or links.";

export const createIntroMessage = (profile) =>
  `Hi, I'm ${profile.name}. ${profile.headline}. Ask me anything about my background.`;

export const generateResponse = (question, profile) => {
  const input = question.trim().toLowerCase();

  if (!input) {
    return `Please type a question. ${defaultPrompt}`;
  }

  if (input.includes("name") || input.includes("who are you")) {
    return `${profile.name} - ${profile.headline}. ${profile.bio}`;
  }

  if (input.includes("bio") || input.includes("about") || input.includes("background")) {
    return profile.bio;
  }

  if (
    input.includes("experience") ||
    input.includes("work") ||
    input.includes("career") ||
    input.includes("job")
  ) {
    return flattenExperience(profile.experience);
  }

  if (
    input.includes("project") ||
    input.includes("portfolio") ||
    input.includes("build") ||
    input.includes("case study")
  ) {
    return flattenProjects(profile.projects);
  }

  if (
    input.includes("skill") ||
    input.includes("stack") ||
    input.includes("tech") ||
    input.includes("tools")
  ) {
    return `Core skills: ${profile.skills.join(", ")}.`;
  }

  if (
    input.includes("contact") ||
    input.includes("email") ||
    input.includes("reach") ||
    input.includes("hire")
  ) {
    return `Email: ${profile.contact.email}\nLocation: ${profile.contact.location}\nAvailability: ${profile.contact.availability}`;
  }

  if (
    input.includes("link") ||
    input.includes("github") ||
    input.includes("linkedin") ||
    input.includes("resume") ||
    input.includes("website")
  ) {
    return Object.entries(profile.links)
      .map(([label, value]) => `${label}: ${value}`)
      .join("\n");
  }

  return `I can only answer using this portfolio profile data. ${defaultPrompt}`;
};
